import { render } from "./portfolio-facilities.vue?vue&type=template&id=9e2419c8&scoped=true&ts=true"
import script from "./portfolio-facilities.vue?vue&type=script&lang=ts"
export * from "./portfolio-facilities.vue?vue&type=script&lang=ts"

import "./portfolio-facilities.vue?vue&type=style&index=0&id=9e2419c8&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2419c8"]])

export default __exports__